const EDITIONS = {
    HONDURAS: 'honduras',
    BOGOTA: 'bogota',
    BUENOSAIRES: 'buenos-aires',
}

export default EDITIONS
